import { appendSnsBtns } from "../functions/sns";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.guide_contents.show").length) return;
  appendSnsBtns();
});
